import React from 'react'

import { CONFIG } from 'config'
import { isRunningInElectron } from 'utils/electron'

// import { telemetryDeck, useTelemetryDeck } from './telemetrydeck'
import { plausible } from './plausible'
import { registerUmamiScript, umamiTrackEvent } from './umami'

export enum PresyncTelemetryEvents {
  SOFTWARE_INSTALL_CLICK = 'SoftwareInstall.click',
  SOFTWARE_INSTALL_DONE = 'SoftwareInstall.done',
  SOFTWARE_INSTALL_ERROR = 'SoftwareInstall.error',
  SOFTWARE_INSTALL_CANCEL = 'SoftwareInstall.cancel',
  APP_REQUIRED_OVERLAY_SHOWN = 'AppRequiredOverlay.Shown',

  INSTALLED_TRACKING_ALERT_SHOWN = 'InstalledTracking.AlertShown',
  INSTALLED_TRACKING_ALLOW = 'InstalledTracking.Allow',
  INSTALLED_TRACKING_DENY = 'InstalledTracking.Deny',
}

export function useInitAnalytics() {
  // useMixpanel()
  // useTelemetryDeck()
  React.useEffect(() => {
    plausible.enableAutoPageviews()

    // We need to set the umami website id based on whether we're in electron or not
    // because we don't want to mix the data
    const UMAMI_WEBSITE_ID = isRunningInElectron
      ? 'e4ba885f-6fa7-42ff-bc31-66592432687a'
      : 'aa09bb6d-3d2a-411e-9c38-ceafafbde3ef'
    registerUmamiScript('https://cloud.umami.is/script.js', UMAMI_WEBSITE_ID, 'app.presync.io')
  }, [])
}

let previousPath: string | null = null
export const analyticsTrackPathChange = () => {
  const currentPath = window.location.pathname
  if (currentPath === previousPath) return
  previousPath = currentPath
  window.umami?.track()
}

export function trackPresyncEvent(event: PresyncTelemetryEvents, payload?: Record<string, any>) {
  if (!CONFIG.ANALYTICS_ENABLED) return

  plausible.trackEvent(event, payload)

  umamiTrackEvent(event, payload)

  // telemetryDeck?.signal(event, payload)

  // Mixpanel is not yet inited
  // if (!MIXPANEL_ENABLED)
  //   setTimeout(() => {
  //     mixpanel.track(event, payload)
  //   }, 1000)
}

trackPresyncEvent.events = PresyncTelemetryEvents
